import React, { Component } from 'react';

import './password-mask-input.css';

class PasswordMaskInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maskedValue: null,
      length: 0
    };
  }

  maskValue(value) {
    let masked = '';

    for (let i = 0; i < value.length - 1; i++) {
      masked += '•';
    }

    masked += value.charAt(value.length - 1);

    return masked;
  }

  scheduleMaskHiding() {
    this.timerID = setTimeout(() => {
      this.setState({
        maskedValue: null
      });
    }, 1000);
  }

  handleChange = (event) => {
    clearTimeout(this.timerID);

    const value = event.target.value;

    if (value.length === this.state.length + 1) {
      this.setState({ length: value.length, maskedValue: this.maskValue(value) });
    } else {
      this.setState({ length: value.length });
    }

    this.scheduleMaskHiding();

    if (this.props.onChange && this.props.onChange !== undefined) {
      this.props.onChange(value);
    }
  };

  componentWillUnmount() {
    clearTimeout(this.timerID);
  }

  render() {
    return (
      <div className='password-mask-container'>
        <input type='password'
                className="form-control"
                {...this.props}
                onChange={this.handleChange} />
        { this.state.maskedValue &&
          <span className="mask">
            {this.state.maskedValue}
          </span>
        }
      </div>
    );
  }
}

export default PasswordMaskInput;



// WEBPACK FOOTER //
// ./src/components/common/form/elements/password-mask-input.jsx